// Mocks
import service1 from "src/assets/mock_images/service_1.png";
import service2 from "src/assets/mock_images/service_2.png";
import service3 from "src/assets/mock_images/service_3.png";

// Helpers
import { AxiosCustomResponse } from "src/helpers/axios.helper";

export const fetchServices = async (): Promise<AxiosCustomResponse<Service[]>> => {
    await new Promise(resolve => setTimeout(resolve, 1000));
    const result: Service[] = [
        {
            id: 1,
            name: "บริการเช่ารถระยะยาว",
            description: "พร้อมบริการเสริมพิเศษมากมาย",
            imageUrl: service1,
        },
        {
            id: 2,
            name: "บริการส่งรถให้คุณ",
            description: "บริการนำรถเช่าไปส่งให้คุณถึงที่",
            imageUrl: service2,
        },
        {
            id: 3,
            name: "บริการเช่ารถระยะยาว 3",
            description: "พร้อมบริการเสริมพิเศษมากมาย",
            imageUrl: service3,
        },
        {
            id: 4,
            name: "บริการส่งรถให้คุณ 4",
            description: "บริการนำรถเช่าไปส่งให้คุณถึงที่",
            imageUrl: service1,
        },
        {
            id: 5,
            name: "บริการส่งรถให้คุณ 5",
            description: "พร้อมบริการเสริมพิเศษมากมาย",
            imageUrl: service2,
        }
    ];
    return { payload: result, success: true };
};